import { render, staticRenderFns } from "./observationsTextArea.vue?vue&type=template&id=849b1100&"
import script from "./observationsTextArea.vue?vue&type=script&lang=js&"
export * from "./observationsTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports